import React, { useEffect, useState } from 'react';
import styledTheme from "common/theme";
import styled from "styled-components";
import { useInformationBar } from "../../providers/InformationBarProvider";
import { useLocation } from 'react-router-dom';


const InformationBarContainer = styled.section`
    background: ${styledTheme.bg.lightPink};
    padding: 0!important;

    &.sticky {
        position: sticky;
        top: 0;
        z-index: 9999999;
        box-shadow: 0px 2px 5px #cdcdcd;
    }
`

export const InformationBar = (): JSX.Element | null=> {

    const { displayComponent } = useInformationBar();
    const [isSticky, setIsSticky] = useState(false);
    const { pathname } = useLocation();

    const { Component, componentProps, displayRoute } = displayComponent

    useEffect(() => {
        const handleScroll = () => {
          setIsSticky(window.scrollY > 0);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);

    const className = isSticky ? 'sticky top-bar' : 'top-bar'

    //we show info bar only on specified page
    if(pathname.indexOf(displayRoute) === -1) return <></>

    if(!Component || !displayRoute) return <></>

    return <InformationBarContainer {...{className}}>
                <Component props={componentProps}/>
            </InformationBarContainer>
}